import type { ReactNode } from 'react';
import type { BoxProps } from '@material-ui/core';
import { Box } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import contentStyles from 'styles/contentBoxItem';
import clsx from 'clsx';

interface ContentBoxItemI extends Omit<BoxProps, 'title'> {
  vertical?: boolean;
  title?: boolean;
  children?: ReactNode | ReactNode[];
}

const ContentBoxItem: FunctionComponent<ContentBoxItemI> = ({
  vertical,
  title,
  children,
  ...props
}: ContentBoxItemI) => {
  const classes = contentStyles();
  return (
    <Box
      className={clsx(classes.item, {
        [classes.itemVertical]: vertical,
        [classes.title]: title
      })}
      {...props}
    >
      {children}
    </Box>
  );
};

export default ContentBoxItem;

ContentBoxItem.defaultProps = {
  vertical: false,
  title: false,
  children: undefined
};
